// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3ci9E","Success":"Button_Success__3K-rK","Danger":"Button_Danger__2tOCV"};